/* global slideUp, slideDown, attachEvent */
// **************************************************
// Toggle filter list
// **************************************************

attachEvent('.filter__placeholder', 'click', ({ target }) => {
  const parentFilterElement = target.closest('.filter');
  const accordionItemContent = parentFilterElement.querySelectorAll('.filter__list')[0];

  if (parentFilterElement.classList.contains('is-open')) {
    parentFilterElement.classList.remove('is-open');
    slideUp(accordionItemContent, 300);
  } else {
    parentFilterElement.classList.add('is-open');
    slideDown(accordionItemContent, 300);
  }
});
